"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  return <section data-section-id="2838" id="heroparallaxoceanview" className="relative min-h-screen w-full overflow-hidden bg-background text-foreground flex items-center justify-center text-center">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/boardroom_ocean_view.png" alt="Luxury boardroom with ocean view" className="h-full w-full object-cover scale-105 transition-transform duration-1000" />
        <div className="absolute inset-0 bg-blue-950/60 backdrop-blur-[1px]" style={{
        background: "linear-gradient(135deg, hsla(222, 47%, 11%, 0.92) 0%, hsla(222, 47%, 11%, 0.75) 50%, hsla(222, 47%, 11%, 0.6) 100%)"
      }} />
      </div>

      {}
      <div className="pointer-events-none absolute inset-x-6 inset-y-6 z-10 border rounded-lg md:inset-x-12 md:inset-y-12 shadow-2xl" style={{
      borderColor: "hsla(43, 48%, 59%, 0.25)",
      background: "hsla(222, 47%, 11%, 0.15)"
    }} aria-hidden="true" />

      {}
      <div className="relative z-25 flex min-h-screen flex-col items-center justify-center px-6 py-32 md:px-16 lg:px-24 max-w-5xl mx-auto">
        <div className="flex flex-col items-center text-center w-full">
          <div className="inline-flex items-center gap-2 px-4 py-2 mb-6 rounded-md backdrop-blur-md border shadow-sm" style={{
          backgroundColor: "hsla(222, 47%, 11%, 0.6)",
          borderColor: "hsla(43, 48%, 59%, 0.3)"
        }}>
            <span className="w-1.5 h-1.5 rounded-lg" style={{
            backgroundColor: "hsl(43, 48%, 59%)"
          }}></span>
            <span className="font-mono text-[11px] uppercase tracking-[0.25em]" style={{
            color: "hsl(43, 48%, 59%)"
          }}>
              STRATEGIC SOLUTIONS
            </span>
          </div>

          <h2 className="font-serif font-bold tracking-tight text-white drop-shadow-lg text-5xl md:text-6xl lg:text-7xl max-w-4xl leading-tight">
            Institutional Expertise, <br />
            <em className="italic font-normal" style={{
            color: "hsl(43, 48%, 59%)"
          }}>
              Coastal
            </em>{" "}
            Perspective
          </h2>

          <p className="mt-6 max-w-2xl font-default text-lg md:text-xl font-light leading-relaxed text-center" style={{
          color: "hsla(210, 20%, 98%, 0.85)"
        }}>
            Boutique sell-side M&amp;A and private investment advisory for exceptional middle-market enterprises across California and nationwide.
          </p>

          {}
          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center justify-center w-full">
            <Button asChild size="lg" className="h-14 px-8 bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg w-full sm:w-auto font-mono text-xs uppercase tracking-[0.2em] shadow-lg border border-[#c5a253]/40 transition-all hover:scale-[1.02]">
              <Link to="/ContactPage">
                SCHEDULE A CONSULTATION
              </Link>
            </Button>

            <Button asChild variant="ghost" size="lg" className="h-14 px-8 border border-white/30 text-white bg-white/5 hover:bg-white/15 backdrop-blur-md rounded-lg w-full sm:w-auto font-mono text-xs uppercase tracking-[0.2em] transition-all hover:scale-[1.02]">
              <Link to="/InsightsPage">
                VIEW OUR INSIGHTS
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}